export const validationJa: any = {
  infantsNumberMessage: "1歳以下の幼児は大人の数以下にしてください",
  requiredInputMessage: "入力してください",
  requiredDateMessage: "日付を入力してください",
  requiredSelectionMessage: "選択してください",
};
